import React from "react";

import ListadoCompras from "../../components/Compras/ListaCompras";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { FetchListadoCompras } from "../../redux/actions/aLogin";
import {ambienteAplicacion} from "../../constants/urls"
import { listarColoresFetch } from "../../redux/actions/aCotizacion";


class ContainerCompras extends React.Component {

async componentDidMount(){
  await this.props.listarColores();
  await this.props.listadoDeCompras(this.props.datosUsuarios.cliCodigoCore,ambienteAplicacion);
}

render() {
    return (
      <main className="bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
            <ListadoCompras/>
          </div>
        </div> 
      </main>
    );
  }
}

const mapStateToProps = state => ({
  datosUsuarios:state.datosUsuarios.dataUsuario,
});

const mapDispatchToProps = dispatch => {
  return {
    listarColores: () => dispatch(listarColoresFetch()),
    listadoDeCompras: (param,ambiente) => dispatch(FetchListadoCompras(param,ambiente)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerCompras)
);
